import { Complement } from "@/shared/recusManager";
import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import moment from "moment/moment";
@Component
export default class BIMixin extends mixins(MyMixin) {
  public montantTickets = {
    ht: 0,
    ttc: 0,
    payByFamille: {},
    pasNet: 0,
    nbr: 0,
  };
  public caParProfit: { [key: string]: number } = {};
  public caParProfitHT: { [key: string]: number } = {};
  public modeEcole = {montantTTC: 0, montantHT: 0, nbr: 0};

  public commandesOuvertes = {
    nbr: 0,
    montant: 0,
    automatiques: 0,
    autoNbr: 0,
  };
  public montantCommandesOuvertes = { ttc: 0, ht: 0 };
  public deliveryParType: { [key: string]: number } = {};
  public discounts: any = { montant: 0, qte: 0, details: {} };
  public saucesOffertes = { montant: 0, qte: 0 };
  public annulations = { nbr: 0, montant: 0 };
  public annulationsDetails = new Array();
  public sommeLines = {
    montant: 0,
    nbr: 0,
    montantNetHT: 0,
    montantNetTTC: 0,
    montantNetTva: 0,
  };
  public venteAnnexe = new Array();
  public montantVA = 0;
  public correctionsParNature: { [key: string]: number } = {
    KIOSK: 0,
    BEFORE_KITCHEN_SCREEN: 0,
    AFTER_ORDER_SUB_TOTAL: 0,
  };
  public correctionsCommandes: { [key: string]: number } = {
    KIOSK: 0,
    BEFORE_KITCHEN_SCREEN: 0,
    AFTER_ORDER_SUB_TOTAL: 0,
  };
  public correctionsTotales: { [key: string]: number } = {};
  public correctionsParProfit: { [key: string]: number } = {};
  public dataDebug = 0;
  public corrections = {
    sommetout: 0,
    automatiques: 0,
    autres: 0,
    qualifier: 0,
    correctionWithParent: 0,
    montantTotal: 0,
    nbr: 0,
  };

  public analyseTickets(ticket: any) {
    // console.log("je suis la ");
    /*if (ticket.ticketID === "a4aa88f1-1122-4a06-965e-3d086dfba65a" ) {

      console.log(ticket);
      let monTicket = 0;
      let montantTouteLignes = 0;
      ticket.invoice.lines.map((line: any) => {
        // pour la bi buffalo
        // this.prixLines.netHT += line.totalNetHT;
        // this.prixLines.netTTC += line.totalNetTTC;
        console.log(line.origin, line.description, line.totalNetHT, line.type, line.parentLine);

        if (null === line.parentLine || line.type === "Q") {
          monTicket += parseFloat(line.totalNetTTC);
        }
        montantTouteLignes += parseFloat(line.totalNetTTC);
      });
      console.log("montant lignes", monTicket);
      // console.log("montant toutes lignes", montantTouteLignes);
      console.log("montant entete", ticket.invoice.totalNetTTC);
    }*/

    if (ticket.invoice.paid) {
      let lignesticket = 0;
      let lignesticketHT = 0;
      this.montantTickets.pasNet += parseFloat(ticket.invoice.totalTTC);
      this.montantTickets.ttc += parseFloat(ticket.invoice.totalNetTTC);
      this.montantTickets.ht += parseFloat(ticket.invoice.totalNetHT);
      this.montantTickets.nbr++;
      let regl = 0;
      ticket.invoice.payments.map((pay: any) => {
        regl += pay.amount;
      });
      if (regl.toFixed(2) !== ticket.invoice.totalNetTTC.toFixed(2)) {
        console.log("-------- Reglement différent montant ticket --------- ");
        console.log(regl, ticket.invoice.totalNetTTC);
        console.log(ticket);
      }
      const locloc = ticket.invoice.origin + "-" + ticket.invoice.destination;
      if (this.caParProfit[locloc] !== undefined) {
        this.caParProfit[locloc] += parseFloat(ticket.invoice.totalNetTTC);
        this.caParProfitHT[locloc] += parseFloat(ticket.invoice.totalNetHT);
      } else {
        this.caParProfit[locloc] = parseFloat(ticket.invoice.totalNetTTC);
        this.caParProfitHT[locloc] = parseFloat(ticket.invoice.totalNetHT);
      }
      /* if (ticket.invoice.origin === "CLICK AND COLLECT") {
            console.log(ticket);
        }*/
      const devType = ticket.invoice.deliveryType;
      if (devType !== "") {
        // console.log(devType);
        if (this.deliveryParType[devType] !== undefined) {
          this.deliveryParType[devType] += parseFloat(
            ticket.invoice.totalNetTTC
          );
        } else {
          this.deliveryParType[devType] = parseFloat(
            ticket.invoice.totalNetTTC
          );
        }
      }
      if (ticket.invoice.discounts.length > 0) {
        // console.log(ticket);
        this.discounts.details[ticket.ticketID] = ticket.invoice.discounts;
        ticket.invoice.discounts.map((discount: any) => {
          if (discount.discountLabel === "[Relivraison]") {
            console.log(discount, ticket);
          }
          if (discount.discountLabel !== "Produit offert") {
            this.discounts.montant += discount.amount;
            this.discounts.qte++;
          } else {
            this.saucesOffertes.montant += discount.amount;
            this.saucesOffertes.qte++;
          }
        });
      }
      if (ticket.invoice.canceledBy) {
        // console.log("annulation ", ticket);
        this.annulations.montant += parseFloat(ticket.invoice.totalNetTTC);
        this.annulations.nbr++;
        this.montantTickets.nbr -= 2;
        this.annulationsDetails.push(ticket);
      }
      ticket.invoice.lines.map((line: any) => {
        if (
          (line.parentLine === null || line.type === "Q") &&
          line.correction === false
        ) {
          lignesticket += parseFloat(line.totalNetTTC);
          lignesticketHT += Number(parseFloat(line.totalNetHT).toFixed(2));
          this.sommeLines.montant += parseFloat(line.totalTTC);
          this.sommeLines.montantNetTTC += line.totalNetTTC;
          this.sommeLines.montantNetHT += Number(line.totalNetHT.toFixed(2));
          this.sommeLines.montantNetTva += line.totalNetTVA;
          this.sommeLines.nbr++;

          if (line.type === "Q") {
            // console.log("type Q", ticket.ticketID, line.description, line.totalNetTTC);
          }
          if (line.correction) {
            // console.log("correction");
          }
        }
        if (line.category === "VENTES ANNEXES") {
          // console.log(line.category, line.totalNetTTC, line.description);
          this.montantVA += line.totalNetTTC;
          this.venteAnnexe.push(line);
        }
        this.analyseCorrections(line, ticket, this.correctionsParNature);
      });

      if (regl.toFixed(2) !== ticket.invoice.totalNetTTC.toFixed(2)) {
        console.log(
          "montant reglement != entete",
          regl,
          ticket.invoice.totalNetTTC.toFixed(2)
        );
        console.log(ticket);
      }

      if (lignesticket.toFixed(2) !== ticket.invoice.totalNetTTC.toFixed(2)) {
        console.log(
          "montant ticket  != montant lignes",
          ticket.invoice.totalNetTTC.toFixed(2),
          lignesticket.toFixed(2)
        );
        console.log(ticket);
      }
      if (lignesticketHT.toFixed(2) !== ticket.invoice.totalNetHT.toFixed(2)) {
        console.log(
          "montant ticket HT  != montant lignes",
          ticket.invoice.totalNetHT.toFixed(2),
          lignesticketHT.toFixed(2)
        );
        console.log(ticket);
        console.log(ticket.ticketID);
      }
    } else {
      // console.log("------OUVERTES-----------");
      this.montantCommandesOuvertes.ttc += parseFloat(
        ticket.invoice.totalNetTTC
      );
      this.montantCommandesOuvertes.ht += parseFloat(ticket.invoice.totalNetHT);
      this.commandesOuvertes.nbr++;
      // console.log(ticket.ticketID, ticket);
      // si le champ canceldBy est à 0, c'est une commande ouverte annulé automatiquement
      if (ticket.invoice.canceledBy === 0) {
        this.commandesOuvertes.autoNbr++;
      }
      // console.log(ticket);
      let commandeTicketsMontant = 0;
      ticket.invoice.lines.map((line: any) => {
        // console.log(line.correctionContext, line.type, line.totalNetTTC, line.description, line.parentLine, line.discount, line.correctionContext, ticket.invoice.dateTicketEnd, ticket.ticketID);
        if (
          line.correctionContext === "AUTOMATIQUE" ||
          line.correctionContext === null
        ) {
          this.commandesOuvertes.montant += parseFloat(line.totalNetTTC);
          commandeTicketsMontant += parseFloat(line.totalNetTTC);
          // commandeTicketsMontant
        } else {
          // console.log("correction commande ouverte", line.totalNetTTC);
        }

        if (
          ticket.invoice.canceledBy === 0 &&
          line.correctionContext === "AUTOMATIQUE"
        ) {
          this.commandesOuvertes.automatiques += parseFloat(line.totalNetTTC);
        }
        this.analyseCorrections(line, ticket, this.correctionsCommandes);
      });
      // console.log("montantCommande ouverte", commandeTicketsMontant, ticket.ticketID);
    }
  }

  public analyseCorrections(line: any, ticket: any, corrections: any) {
    switch (this.client) {
      case "BK":
        this.analyseCorrectionsBK(line, ticket, this.correctionsCommandes);
        break;
      case "BUFFALO":
      case "COURTEPAILLE":
      case "LEON":
      case "HIPPO":
        this.analyseCorrectionsCHR(line, ticket, this.correctionsCommandes);
        break;
    }
  }
  /**
   * methode de calcul des corrections
   * séparation en auto / non automatique (automatique = annulation des commandes ouvertes)
   * avant apres selon le correctionContext
   * kiosk si operator = 0
   * delivery selon le profit du ticket
   *
   *     -	Identification d’une commande ouverte :
   *     o	Sur l’en-tête (invoice), filtre sur le champ paid = ‘false’
   *     o	Sur les lignes, prendre et sommer le montant totalNetTTC
   *    -	Identification d’une annulation automatique de commande ouverte :
   *    o	Filtre sur cancelledby = 0 (ces commandes sont annulées automatiquement en fin de journée)
   *    -	Identification des corrections sur des commandes ouvertes :
   *    o	Même règle que pour le rapport Corrections sauf :
   *    o	Filtre sur le champ paid = ‘false’
   *    o	Supprimer les filtres sur parentline (PARENTNUMBERUUID) et type
   */
  public analyseCorrectionsBK(line: any, ticket: any, corrections: any) {
    // console.log("*** analyse corrections*** ");
    // console.log(line);
    // console.log(line.type, line.correctionContext, line.parentLine, line.totalNetTTC, line.description, ticket.invoice.dateTicketEnd, ticket.ticketID);
    if (line.correction && line.correctionContext !== "AUTOMATIQUE") {
      this.corrections.sommetout += line.totalTTC;
      if (ticket.invoice.origin.includes("CLICK")) {
        if (
          corrections[origin] !== undefined &&
          (line.parentLine === null || line.type === "Q")
        ) {
          corrections[origin] += parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        } else if (line.parentLine === null || line.type === "Q") {
          corrections[origin] = parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        }
        if (this.correctionsParProfit[origin] !== undefined) {
          this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
        } else {
          this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
        }
      }
      if (ticket.invoice.origin.includes("DELIVERY")) {
        const origin = ticket.invoice.origin;
        // console.log("correction Delivery", line.totalTTC, );
        // console.log(">>>", ticket.invoice.origin,  ticket.invoice.destination, line.operator, line.correctionContext, line.type, line.description, line.totalTTC, line.correctionContext, line.category, line.parentLine);
        if (
          corrections[origin] !== undefined &&
          (line.parentLine === null || line.type === "Q")
        ) {
          corrections[origin] += parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        } else if (line.parentLine === null || line.type === "Q") {
          corrections[origin] = parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        }
        if (this.correctionsParProfit[origin] !== undefined) {
          this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
        } else {
          this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
        }
      } else {
        if (line.parentLine === null) {
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
          const origin = ticket.invoice.origin;
          if (this.correctionsParProfit[origin] !== undefined) {
            this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
          } else {
            this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
          }
          if (line.operator === 0) {
            corrections.KIOSK += parseFloat(line.totalTTC);
          } else {
            if (
              line.correctionContext.includes("KITCHEN") ||
              line.correctionContext.includes("BEFORE_SUBTOTAL")
            ) {
              corrections.BEFORE_KITCHEN_SCREEN += parseFloat(line.totalTTC);
              // console.log(line);
              // console.log(line.totalTTC, typeof line.totalTTC);
            } else if (line.correctionContext.includes("AUTOMATIQUE")) {
              this.corrections.automatiques += parseFloat(line.totalTTC);
            } else {
              // AFTER_ORDER_SUB_TOTAL
              corrections.AFTER_ORDER_SUB_TOTAL += parseFloat(line.totalTTC);
            }
          }
        } else if (line.parentLine) {
          if (line.type === "Q") {
            this.corrections.montantTotal += parseFloat(line.totalTTC);
            this.corrections.nbr++;
            const origin = ticket.invoice.origin;
            if (this.correctionsParProfit[origin] !== undefined) {
              this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
            } else {
              this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
            }
            this.corrections.correctionWithParent += parseFloat(line.totalTTC);
            if (line.operator === 0) {
              corrections.KIOSK += parseFloat(line.totalTTC);
              this.corrections.qualifier += parseFloat(line.totalTTC);
            } else {
              this.corrections.qualifier += parseFloat(line.totalTTC);
              // console.log(line.line);
              if (
                line.correctionContext.includes("KITCHEN") ||
                line.correctionContext.includes("BEFORE_SUBTOTAL")
              ) {
                corrections.BEFORE_KITCHEN_SCREEN += parseFloat(line.totalTTC);
              } else {
                // AFTER_ORDER_SUB_TOTAL
                corrections.AFTER_ORDER_SUB_TOTAL += parseFloat(line.totalTTC);
              }
            }
          }
        }
      }
    } else if (line.correction && line.correctionContext === "AUTOMATIQUE") {
      this.corrections.automatiques += line.totalTTC;
    }
  }
  /**
   * methode de calcul des corrections pour le CHR
   * delivery selon le profit du ticket
   *
   */
  public analyseCorrectionsCHR(line: any, ticket: any, corrections: any) {
    // console.log("*** analyse corrections*** ");
    // console.log(line.type, line.correctionContext, line.parentLine, line.totalNetTTC, line.description, ticket.invoice.dateTicketEnd, ticket.ticketID);
    if (line.correction) {
      this.corrections.sommetout += line.totalTTC;
      if (ticket.invoice.origin.includes("CLICK")) {
        if (
          corrections[origin] !== undefined &&
          (line.parentLine === null || line.type === "Q")
        ) {
          corrections[origin] += parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        } else if (line.parentLine === null || line.type === "Q") {
          corrections[origin] = parseFloat(line.totalTTC);
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
        }
        if (this.correctionsParProfit[origin] !== undefined) {
          this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
        } else {
          this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
        }
      }

      if (line.parentLine === null) {
        this.corrections.montantTotal += parseFloat(line.totalTTC);
        this.corrections.nbr++;
        const origin = ticket.invoice.origin;
        if (this.correctionsParProfit[origin] !== undefined) {
          this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
        } else {
          this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
        }
      } else if (line.parentLine) {
        if (line.type === "Q") {
          this.corrections.montantTotal += parseFloat(line.totalTTC);
          this.corrections.nbr++;
          const origin = ticket.invoice.origin;
          if (this.correctionsParProfit[origin] !== undefined) {
            this.correctionsParProfit[origin] += parseFloat(line.totalTTC);
          } else {
            this.correctionsParProfit[origin] = parseFloat(line.totalTTC);
          }
          this.corrections.correctionWithParent += parseFloat(line.totalTTC);
        }
      }
    }
  }
  /**
   * methode de calcul des montant par moyen de paiement
   */
  public calculatePayments(tickets: any) {
    const payObj: any = {};
    // console.log(tickets);
    tickets.map((ticket: any) => {
      if (ticket.trainingMode !== null && !ticket.trainingMode) {
      ticket.invoice.payments.map((pay: any) => {
        if (payObj[pay.labelPayment] !== undefined) {
          payObj[pay.labelPayment] += pay.amount;
        } else {
          payObj[pay.labelPayment] = pay.amount;
        }
      });
    } else {

      this.modeEcole.montantHT += ticket.invoice.totalNetHT;
      this.modeEcole.montantTTC += ticket.invoice.totalNetTTC;
      this.modeEcole.nbr++;
    }
  });
    // console.log(payObj);
    this.montantTickets.payByFamille = payObj;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
